import { render, staticRenderFns } from "./AddressGroup.vue?vue&type=template&id=7b5eb84d&scoped=true&"
import script from "./AddressGroup.vue?vue&type=script&lang=js&"
export * from "./AddressGroup.vue?vue&type=script&lang=js&"
import style0 from "./AddressGroup.vue?vue&type=style&index=0&id=7b5eb84d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5eb84d",
  null
  
)

component.options.__file = "AddressGroup.vue"
export default component.exports